export const ONBOARDING_ROUTES = {
    ONBOARDING: "onboarding",
    COMPANY: "company",
    WELCOME: "welcome",
    COMPANY_SIZE: "companysize",
    FORM_QUANTITY: "formquantity",
    ACCOUNTING_SOFTWARES: "softwares",
}

export const ONBOARDING_LOADING_STATES = {
    ONBOARDING_PAGE_LOADING: "ONBOARDING_PAGE_LOADING",
    ONBOARDING_PAGE_READY: "ONBOARDING_PAGE_READY",
    SAVE_ONBOARDING_ACTION_LOADING: "SAVE_ONBOARDING_ACTION_LOADING",
    SAVE_ONBOARDING_ACTION_READY: "SAVE_ONBOARDING_ACTION_READY",
}

export const ONBOARDING_STATES_MESSAGE_MAP = {
    [ONBOARDING_LOADING_STATES.ONBOARDING_PAGE_LOADING]: "",
    [ONBOARDING_LOADING_STATES.SAVE_ONBOARDING_ACTION_LOADING]: "",
}

export const COMPANY_NAME_TEXT = "CompanyName"
export const PHONE_NUMBER_TEXT = "PhoneNumber"
